export default "__VITE_ASSET__32944ae0__"